import {FC, useState} from "react";
import {App, Button, Empty, Flex, Input} from "antd";
import {EventComment, Event, EventApprover} from "../../../../types/domain.ts";
import {Comment} from "./Comment.tsx";
import {SendOutlined} from "@ant-design/icons";
import {eventsEventIdCommentsPost} from "../../../../api/events/eventsEventIdCommentsPost.ts";
import styles from './EventCommentsContent.module.css';
import {PrivateCommentOption} from "./PrivateCommentOption.tsx";

type Props = {
    event: Event;
    comments: EventComment[];
    onUpdate: VoidFunction;
    approvers?: EventApprover[];
}

export const EventCommentsContent: FC<Props> = ({ event, comments, onUpdate, approvers }) => {
    const { message } = App.useApp();
    const [commentValue, setCommentValue] = useState('');
    const [privateFor, setPrivateFor] = useState<number>();

    const [loading, setLoading] = useState(false);
    const handleAddComment = () => {
        if(!commentValue) return;

        setLoading(true);
        eventsEventIdCommentsPost(event.id, { content: commentValue, private_for: privateFor }).then(() => {
            void message.success('Комментарий добавлен');
            onUpdate();
            setCommentValue('');
            setPrivateFor(undefined);
        }).catch((e) => {
            console.error(e);
            void message.error(`Ошибка (${JSON.stringify(e)})`);
        }).finally(() => setLoading(false));
    }

    return (
        <Flex vertical justify="space-between" flex="1 0">
            <Flex vertical gap={8} flex="1 0" className={styles.scroll}>
                {Boolean(comments?.length) ? comments!.map((comment) => (
                    <Comment key={comment.id} comment={comment} />
                )) : (
                    <Empty description="Пока тут ничего нет!" />
                )}
            </Flex>
            <Flex vertical gap={8}>
                <Input.TextArea
                    rows={3}
                    placeholder="Ввведите комментарий..."
                    value={commentValue}
                    onChange={({ target }) => setCommentValue(target.value)}
                    onKeyUp={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            handleAddComment();
                        }
                    }}
                    disabled={loading}
                />
                <Flex justify="space-between">
                    <PrivateCommentOption
                        userId={privateFor}
                        onSelect={setPrivateFor}
                        approvers={approvers}
                        createdBy={event.created_by}
                    />
                    <Button
                        type="primary"
                        icon={<SendOutlined />}
                        loading={loading}
                        onClick={handleAddComment}
                    >Отправить (Enter)</Button>
                </Flex>
            </Flex>
        </Flex>
    )
}